import { uniqueId } from 'lodash';
export const getKey = ({ commentId, localId }) => {
    // When generating key we don't want React to remount component, so if the localId exists we
    // prefer it over commentId
    return (localId || commentId);
};
export const getHtmlId = ({ commentId, localId }) => {
    // When generating html ids we prefer commentId as the reducers drop localId right after
    // id from server is received
    return makeHtmlId((commentId || localId));
};
// We need some comment id for optimistic updates so we generate it with this function. Be ware
// to use it only in component side, because if used in worker it will generate same ids
// and unexpected things will happen!!!
export const generateLocalCommentId = () => uniqueId('local-comment-id');
export const makeHtmlId = (id) => {
    // Prefix 'C-' is added to conform to html id standard
    return `C-${id}`;
};
export const makeCommentInnerListId = (resourceId) => `comment-list-inner-${resourceId}`;
//# sourceMappingURL=id-utils.js.map